const  projectsReact = [
    {
       proTitle: "React projects", 
       projectProps: [
            {
                title: "React fundamentals",
                img: "./img_projects/React/project1.png",
                desc: "Tutte le caratteristiche principali della libreria ReactJS.",
                long_desc: "Questa applicazione permette di osservare le pricipali caratteristiche della libreria ReactJS mentre sono in funzione su un web server.",
                topics: "Javascript, ES6, JSON",
                location_url: "./web_app/projects/reactJS/react-fundamentals/index.html",
                source_code: false
            },
            {
                title: "Rick Wiki",
                img: "./img_projects/React/project2.png",
                desc: "Gestrire una restAPI al fine di creare una piccola wiki",
                long_desc: "Il progetto permette di creare una semplice applicazione che fornisce delle informazioni inerenti ai protagonisti della serie animata Rick and Morty.",
                topics: "React, Laravel, Javascript, ES6, JSON",
                location_url: "https://github.com/pippo-github/react-laravel-RickWikiRestAPI",
                source_code: true
            },
            // {
            //     title: "project React 3",
            //     img: "./img_projects/React/project3.png",
            //     desc: "Tutte le caratteristiche principali della libreria ReactJS..",
            //     long_desc: "Tutte le caratteristiche principali della libreria ReactJS.Tutte le caratteristiche principali della libreria ReactJS.",
            //     topics: "Javascript, ES6, JSON",
            //     location_url: "./web_app/projects/php/savio_sito/index.php",
            //     source_code: true
      
            // },
            // {
            //     title: "project React 4",
            //     img: "./img_projects/React/2.png",
            //     desc: "All the main features of the React library.",
            //     long_desc: "Tutte le caratteristiche principali della libreria ReactJS.Tutte le caratteristiche principali della libreria ReactJS.",
            //     topics: "Javascript, ES6, JSON",
            //     location_url: "./web_app/projects/php/savio_sito/index.php",
            //     source_code: true
      
            // }

        ]
    }
]

export {projectsReact}
